
import { TranslationSet } from '../types';

export const auth: TranslationSet = {
  'auth.loginTitle': {
    en: 'Login',
    ja: 'ログイン',
    es: 'Iniciar sesión',
    zh: '登录',
    fa: 'ورود'
  },
  'auth.signupTitle': {
    en: 'Sign Up',
    ja: 'サインアップ',
    es: 'Registrarse',
    zh: '注册',
    fa: 'ثبت نام'
  },
  'auth.email': {
    en: 'Email',
    ja: 'メールアドレス',
    es: 'Correo electrónico',
    zh: '电子邮件',
    fa: 'ایمیل'
  },
  'auth.password': {
    en: 'Password',
    ja: 'パスワード',
    es: 'Contraseña',
    zh: '密码',
    fa: 'رمز عبور'
  },
  'auth.name': {
    en: 'Name',
    ja: '名前',
    es: 'Nombre',
    zh: '名字',
    fa: 'نام'
  },
  'auth.confirmPassword': {
    en: 'Confirm Password',
    ja: 'パスワードを確認',
    es: 'Confirmar contraseña',
    zh: '确认密码',
    fa: 'تایید رمز عبور'
  },
  'auth.loginButton': {
    en: 'Login',
    ja: 'ログイン',
    es: 'Iniciar sesión',
    zh: '登录',
    fa: 'ورود'
  },
  'auth.signupButton': {
    en: 'Sign Up',
    ja: 'サインアップ',
    es: 'Registrarse',
    zh: '注册',
    fa: 'ثبت نام'
  },
  'auth.googleLogin': {
    en: 'Sign in with Google',
    ja: 'Googleでサインイン',
    es: 'Iniciar sesión con Google',
    zh: '使用Google登录',
    fa: 'ورود با گوگل'
  },
  'auth.alreadyAccount': {
    en: 'Already have an account?',
    ja: 'すでにアカウントをお持ちですか？',
    es: '¿Ya tienes una cuenta?',
    zh: '已经有账户了吗？',
    fa: 'قبلاً حساب کاربری دارید؟'
  },
  'auth.noAccount': {
    en: 'Don\'t have an account?',
    ja: 'アカウントをお持ちでないですか？',
    es: '¿No tienes una cuenta?',
    zh: '没有账户吗？',
    fa: 'حساب کاربری ندارید؟'
  }
};
